/* eslint react/jsx-no-duplicate-props: 0 */
/* dear eslint, inputProps are not the same as InputProps! */
import React, { Component } from 'react'
import { Icon, TextField } from '@material-ui/core'
import PhoneNumberTextField from 'components/masks/PhoneNumberTextField'

export default class FaxCellEditor extends Component {
  constructor(...args) {
    super(...args)
    this.state = {
      value: this.props.value
    }
  }

  componentWillUnmount() {
    let { value } = this.state
    if (value) {
      value = value
        .replace('(', '')
        .replace(') ', '-')
        .replace(' ', '')
    }
    this.props.onChange(this.props.field, value, this.props.node)
  }

  onChange = e => {
    const { value } = e.target
    console.log(value)
    this.setState({ value })
  }

  getValue = () => this.state.value

  render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%'
        }}
      >
        <div
          style={{
            display: 'flex',
            flex: 0.9,
            height: '100%',
            width: '!00%'
          }}
        >
          <div style={{ alignSelf: 'flex-end' }}>
            <TextField
              value={this.state.value}
              readOnly
              onChange={this.onChange}
              InputProps={{
                inputComponent: PhoneNumberTextField,
                style: { height: 26, padding: 0 }
              }}
              style={{ height: 26, padding: 0 }}
              inputProps={{
                style: { height: 26, padding: 0 }
              }}
              fullWidth
            />
          </div>
        </div>
        <div
          style={{
            flex: 0.1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
            // marginRight: -10
          }}
        >
          {!this.state.value ? (
            <Icon
              style={{
                color: '#d9534f',
                fontSize: 16
              }}
            >
              error_outline
            </Icon>
          ) : null}
        </div>
      </div>
    )
  }
}
